import { IonCol, IonImg, IonLabel, IonRow, IonToggle } from '@ionic/react';
import { Trans } from '@lingui/macro';
import React from 'react';

type SmartMeterProps = {
    hasSmartMeter: boolean;
    hasSmartMeterSealed: boolean;
    onHasSmartMeterChange: (hasSmartMeter: boolean) => void;
    onHasSmartMeterSealedChange: (hasSmartMeterSealed: boolean) => void;
};

const SmartMeter: React.FunctionComponent<SmartMeterProps> = ({
    hasSmartMeter,
    hasSmartMeterSealed,
    onHasSmartMeterChange,
    onHasSmartMeterSealedChange,
}) => {
    const linkySealedQuestion = hasSmartMeter ? (
        <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-bottom">
            <IonCol>
                <IonLabel>
                    <Trans>Is the Linky Meter locked?</Trans>
                </IonLabel>
            </IonCol>
            <IonCol size="auto">
                <IonToggle
                    color="primary"
                    onIonChange={(e) =>
                        onHasSmartMeterSealedChange(e.detail.checked)
                    }
                    checked={hasSmartMeterSealed}
                />
            </IonCol>
        </IonRow>
    ) : null;
    const linkySealedPhoto =
        hasSmartMeterSealed && hasSmartMeter ? (
            <IonRow className="ion-justify-content-between ion-align-items-center ion-margin-bottom">
                <div className="smart-meter-img-container">
                    <IonImg
                        src="/assets/smart_meter_help.png"
                        alt="smart_meter_help"
                    />
                </div>
            </IonRow>
        ) : null;
    return (
        <>
            <IonRow className="ion-margin-bottom ion-justify-content-between ion-align-items-center">
                <IonCol>
                    <IonLabel>
                        <Trans>Is a Linky Meter installed?</Trans>
                    </IonLabel>
                </IonCol>
                <IonCol size="auto">
                    <IonToggle
                        color="primary"
                        onIonChange={(e) =>
                            onHasSmartMeterChange(e.detail.checked)
                        }
                        checked={hasSmartMeter}
                    />
                </IonCol>
            </IonRow>
            {linkySealedQuestion}
            {linkySealedPhoto}
        </>
    );
};

export default SmartMeter;
